import React from 'react';
import HeroContent from '../HeroContent';
import Footer from '../Footer';
import Content from '../Content';
import AsyncContent from '../AsyncContent';

import '../../styles/utils.less';
import './DisplayWhenLoaded.less';

const App = () => (
  <React.Fragment>
    <HeroContent />
    <Content />
    <Footer />
    <AsyncContent />
  </React.Fragment>
);


export default App;
